<div class="row pad25 mobHeight bgModal" style="margin: 0px;">
    <div class="col-md-12 col-12 col-sm-12">
        <div class="col-md-8 col-5 col-sm-8 pad0 inLneBlk newHeader" style="vertical-align: top;">
            <h4>{{modalHeader}}</h4>
        </div>
        <div class="col-md-4 col-7 col-sm-4 txtRight pad0 inLneBlk fn13">
            <span *ngIf="!showAsPage"  class="btn btn-darkGreen brdrRadius3" style="margin: 0px 10px 0px 10px; padding: 5px 8px; font-size: 14px; line-height: 18px;" (click)="save()">
                <i class="fa fa-check" style="margin-right: 5px;"></i>
                Save
            </span>
            <span class="mobView" style="display: inline;">
                <span *ngIf="!showAsPage" class="closeMdl ng-scope" (click)="closeModel('')" style="padding: 5px 10px !important;">
                    <i class="zmdi zmdi-close"></i>
                </span>
                <span *ngIf="showAsPage" class="btn darkBlueButton" (click)="backToHomeBtn()">
                    <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
                </span>
            </span>
            <span class="webView" style="display: inline;">
                <span class="closeMdl ng-scope" (click)="closeModel('')" style="padding: 5px 10px !important;">
                    <i class="zmdi zmdi-close"></i>
                </span>
            </span>
        </div>
        <div class="row">
            <!--task-->
            <div class="col-md-12 col-sm-12 col-12 pdng mrgnTp10" style="text-align: left;">
                <div class="label-new">Enter Task </div>
                <input type="text" [(ngModel)]="objTaskEntry.task"  class="form-control fn13 formCtlFltr crntColor" maxlength="150" style="background-color: white !important;">
            </div>
            <!--Select Executive-->
            <!-- <div *ngIf="isUserShow" class="col-md-12 col-sm-12 col-12" style="padding: 15px 15px; display: inline-block; margin-top: 0px;">  
                <span class="label fn13 bz-orgBtn-lb brdrRadius3" (click)="selectExe(selectExcUser)">
                    <span>Assign to : {{userListID == objTaskEntry.toUserID ? 'Me' : objTaskEntry.toUserName}}</span>
                    <span style="margin-left: 10px; cursor: pointer;"><i class="fa fa-pencil"></i></span>
                </span>
            </div> -->
            <div class="col-md-12 col-sm-12 col-12 pdng mrgnTp10" style="text-align: left;">
                <div class="label-new">Assign to</div>
                <mat-select class="form-control fn13 formCtlFltr crntColor" 
                            [(ngModel)]="assignedUserID" 
                            (selectionChange)="selectExeChane()" placeholder="Select Executive">
                    <mat-option [value]="userListID">Me</mat-option>
                    <ng-container *ngFor="let u of userList">
                        <mat-option [value]="u.UserID" *ngIf="u.UserID != userListID">
                            {{ userListID == u.UserID ? 'Me' : u.Name}}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </div>
            
            <div class="col-md-12 col-sm-12 col-12 mrgnTp10" *ngIf="!showProjectSelection && agnERPRight.EnblProjects && (!objTaskEntry.projectName || !objTaskEntry.projectStageName)">
                <div class="brdrRadius3">
                    <span class="linkPrjBtn darkBlueBadge brdrRadius3" (click)="showProjectSelection = !showProjectSelection"><i class="zmdi zmdi-link" style="margin-right: 7px; font-size: 14px; vertical-align: middle;"></i> <span style="vertical-align: middle;">Link Project</span></span>
                </div>
            </div>
            <!-- Project and Project Stage -->
            <div class="col-md-12 col-sm-12 col-12 pdng mrgnTp10" 
                *ngIf="showProjectSelection && agnERPRight.EnblProjects && (!objTaskEntry.projectName || !objTaskEntry.projectStageName)" 
                [style]="isMobileView ? 'display: block' : 'display: flex; gap: 10px'">

                <!-- Project Dropdown -->
                <div [style]="isMobileView ? 'width: 100%; margin-bottom: 10px' : 'width: 50%'" style="text-align: left;">
                    <div class="label-new">Project</div>
                    <mat-select class="form-control fn13 formCtlFltr crntColor"
                        [(ngModel)]="objTaskEntry.projectID"
                        (selectionChange)="selectProjectChange()" placeholder="Select Project">
                        <!-- <mat-option [value]="0" style="display: none;">Select Project</mat-option> -->
                        <mat-option *ngFor="let p of projectList" [value]="p.JobID">
                            {{p.JobNo}}
                        </mat-option>
                    </mat-select>
                </div>

                <!-- Project Stage Dropdown -->
                <div *ngIf="projectStageList.length > 0" 
                    [style]="isMobileView ? 'width: 100%' : 'width: 50%'" 
                    style="text-align: left;">
                    <div class="label-new">Project Stage</div>
                    <mat-select class="form-control fn13 formCtlFltr crntColor"
                        [(ngModel)]="objTaskEntry.projectStageID" placeholder="Select Project Stage">
                        <!-- <mat-option [value]="0" style="display:  none;">Select Project Stage</mat-option> -->
                        <mat-option *ngFor="let ps of projectStageList" [value]="ps.SID">
                            {{ps.SNm}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>

            <div class="col-md-12 col-sm-12 col-12 pdng mrgnTp10" *ngIf="agnERPRight.EnblProjects && objTaskEntry.projectName && objTaskEntry.projectStageName">
                <div class="label-new">Project</div>
                <div class="bzInput crntColor" style="font-size: 13px; padding: 5px; border-color: #BCC2C9 !important; width: 100%;">
                    {{objTaskEntry.projectName}} &nbsp; > &nbsp; {{objTaskEntry.projectStageName}}
                </div>
            </div>
            

            <!--Add Details/Description-->
            <!-- <div class="col-md-12 col-sm-12 col-12" style="margin-top: 0px; cursor: pointer;" *ngIf="!isShowDis">
                <span  (click)="isShowDis = !isShowDis" class="mrgnTp10 fn13" style="color: #808080;" >
                    <i class="zmdi zmdi-plus" style="padding-right: 3px;" ></i>Add Description
                </span>
            </div> -->

            <!--Add Description-->
            <div class="col-md-12 col-sm-12 col-12 inLneBlk pdng mrgnTp10" style="text-align: left;">
                <div class="label-new">Description</div>
                <textarea rows="4" [(ngModel)]="objTaskEntry.detail"  maxlength="500"  class="txtArea fn13 brdrRadius3 crntColor" style="border-color: #BCC2C9; resize: none;"></textarea>
            </div>
            
            <!--Status / Assign Default Status = 0 -->
            <div class="col-md-12 col-sm-12 col-12" style="padding: 5px 0px 0px 15px; display: none;">
                <div class="btn-group" role="group" aria-label="Basic example" style="display: none;">
                    <span type="button" class="btn btn-secondary fn13 {{objTaskEntry.statusID == 0 ? 'activeStatus' : ''}}" (click)="changeStatus(0);">Pending</span>
                    <span type="button" class="btn btn-secondary fn13 {{objTaskEntry.statusID == 1 ? 'activeStatus' : ''}}" (click)="changeStatus(1);">Paused</span>
                    <span type="button" class="btn btn-secondary fn13 {{objTaskEntry.statusID == 2 ? 'activeStatus' : ''}}" (click)="changeStatus(2);">Cencel</span>
                    <span type="button" class="btn btn-secondary fn13 {{objTaskEntry.statusID == 3 ? 'activeStatus' : ''}}" (click)="changeStatus(3);">Done</span>
                </div>
                <span class="label fn13 tealBadge {{objTaskEntry.statusID == 0 ? 'activeTeal' : ''}}" (click)="changeStatus(0);"
                        style="cursor: pointer; margin-left: 0px;margin-right: 5px;">
                    <i class="fa fa-clock-o mrgri8" aria-hidden="true"></i>
                    <span >Pending</span>
                </span>
                <span class="label fn13 blueBadge {{objTaskEntry.statusID == 1 ? 'activeBlue' : ''}}" (click)="changeStatus(1);" 
                        style="cursor: pointer; margin-left: 5px;margin-right: 5px;">
                    <i class="zmdi zmdi-pause mrgri8" aria-hidden="true"></i> 
                    <span>Paused</span></span>
                <span class="label fn13 darkBlueBadge {{objTaskEntry.statusID == 2 ? 'activedarkblue' : ''}}" (click)="changeStatus(2);" 
                        style="cursor: pointer; margin-left: 5px;margin-right: 5px;">
                    <i class="fa fa-ban mrgri8" aria-hidden="true"></i>
                    <span>Cancelled</span></span>
                <span class="label fn13 greenBadge {{objTaskEntry.statusID == 3 ? 'activeGreen' : ''}}" (click)="changeStatus(3);" 
                        style="cursor: pointer; margin-left: 5px">
                    <i class="fa fa-check mrgri8" aria-hidden="true"></i>
                    <span>Done</span>
                </span>
            </div>

            <!--Priority-->
            <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 20px 0px 0px 15px; display: none;">               
                <div class="btn-group" role="group" aria-label="Basic example" style="display: none;">
                    <span type="button" class="btn btn-secondary fn13 {{objTaskEntry.priorityID == 1 ? 'activeStatus' : ''}}" (click)="changePriority(0);">High</span>
                    <span type="button" class="btn btn-secondary fn13 {{objTaskEntry.priorityID == 0 ? 'activeStatus' : ''}}" (click)="changePriority(1);">Normal</span>
                    <span type="button" class="btn btn-secondary fn13 {{objTaskEntry.priorityID == 2 ? 'activeStatus' : ''}}" (click)="changePriority(2);">Low</span>
                </div>
                <span class="label fn13 orangeBadge {{objTaskEntry.priorityID == 1 ? 'activeOrange' : ''}}" (click)="changePriority(1);"
                style="cursor: pointer; margin-left: 0px;margin-right: 5px;">
                <i class="zmdi zmdi-long-arrow-up mrgri8" aria-hidden="true"></i>
                <span >High</span></span>
                <span class="label fn13 yellowBadge {{objTaskEntry.priorityID == 0 ? 'activeYellow' : ''}}" (click)="changePriority(0);" 
                style="cursor: pointer; margin-left: 5px;margin-right: 5px;">
                <i class="zmdi zmdi-pause mrgri8" aria-hidden="true"></i> 
                <span>Normal</span></span>
                <span class="label fn13 greenBadge {{objTaskEntry.priorityID == 2 ? 'activeGreen' : ''}}" (click)="changePriority(2);" 
                style="cursor: pointer; margin-left: 5px;margin-right: 5px;">
                <i class="zmdi zmdi-long-arrow-down mrgri8" aria-hidden="true"></i>
                    <span>Low</span></span>
                    <!-- <span style="margin-top:2px; margin-right: 8px;font-size:25px;color:#008080;"><i class="zmdi zmdi-account"></i></span>  -->
            </div>

            <!-- Add Tag -->
            <div class="col-md-12 col-sm-12 col-12" style="margin-top: 5px; display: none;">
                <span *ngIf="!isShowTag" (click)="isShowTag = !isShowTag"  class="mrgnTp10 fn13" style="border-radius: 25px; color: #4caf50;;" >
                    <i class="zmdi zmdi-plus" style="padding-right: 3px;" ></i>Add Tags
                </span>
            </div>
            <!-- show Tag Box -->
            <div *ngIf="isShowTag" class="col-md-12 col-sm-12 col-12 mrgnTp10 display: none">
                <div class="col-md-12 col-sm-12 col-12 pad0" style="vertical-align: top; display: inline-block; line-height: 1.5;">
                            <input class="form-control fn13" placeholder="Enter Tag"  maxlength="20" [(ngModel)]="data.tag" style="display: inline-block;
                            width: 30%;">
                    <span style="margin-left: 5px; font-size: 18px; color: #e88421; cursor: pointer;"  (click)="tagEntry()">
                        <i class="zmdi zmdi-plus"></i>
                    </span>
                </div>    
            </div>
            <div  class="col-md-12 col-sm-12 col-12 inLneBlk pad0" style="display: inline-block; display: none;">
                <div class="TagLeft0 inLneBlk tagStyle"
                *ngFor="let x of tagList; let i = index">
                <span>
                    {{x}}
                </span>
                    <span style="margin-left: 10px; cursor: pointer;" (click)="removeTagSearch(i)">
                        <i class="zmdi zmdi-close"></i>
                    </span>
                </div>
            </div>

            <div class="col-md-12 col-sm-12 col-12" style="display: flex; align-items: center;">
                <!-- <span style="margin-top:2px; margin-right: 8px;font-size:25px;color:#008080;"><i class="zmdi zmdi-account"></i></span> 
                <select class="form-control fn13 mobWdth" style="border-radius: 0px !important; width: 80%;">
                    <option value="0">Select Executive</option>
                    <option>{{executiveName}}</option>
                </select> -->
                <div class="col-md-4 col-sm-4 col-4" style="padding-left: 0px; padding-right: 10px;">
                    <div class="label-new">Priority</div>
                    <mat-select 
                        class="form-control fn13 mrgRight formCtlFltr crntColor"
                        [(ngModel)]="objTaskEntry.priorityID"
                        (selectionChange)="changePriority($event.value)"
                        style="cursor: pointer; font-size: 13px !important; display: inline-block; border-radius: 3px !important; margin: 0px; background-color: white !important;">
                        <mat-option [value]="0">High</mat-option>
                        <mat-option [value]="1">Normal</mat-option>
                        <mat-option [value]="2">Low</mat-option>
                    </mat-select>
                </div>

                <!--Due by-->
                <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; padding:0px;">
                    <span class="label-new">Due on </span>
                    <div style="width: 100%; outline: none !important; font-size: 13px !important; line-height: normal; margin-top: -3px;">
                        <input readonly [matDatepicker]="picker" (click)="picker.open()" [min]="minDate"
                                class="form-control fn13 dtWdth formCtlFltr crntColor" [(ngModel)]="objTaskEntry.taskDate" tabindex="1"
                                style="display: inline-block; width: 40%; background: #FFF; cursor: pointer; background-color: white !important;">
                        <mat-datepicker-toggle  matSuffix [for]="picker" style="display: inline-block;"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </div>
                </div> 
            </div>
            <!--Save-->
            <div class="col-md-12 col-sm-12 col-12 fn13" style="margin-top:10px;">
                <div style="display: flex; column-gap: 10px;">
                    <span class="btn btn-darkGreen brdrRadius3" (click)="save()" style="padding: 5px 8px; font-size: 14px; line-height: 18px;">
                        <i class="fa fa-check" style="margin-right: 5px;"></i>
                        Save
                    </span>
                    <span class="mobView" style="display: inline;">
                        <span *ngIf="!showAsPage" class="btn btn-darkBlue brdrRadius3" (click)="closeModel('')" style="padding: 5px 8px; font-size: 14px; line-height: 18px;">
                            <i class="fa fa-close" style="margin-right: 5px;"></i>
                            Close
                        </span>
                        <span *ngIf="showAsPage" class="btn darkBlueButton" (click)="backToHomeBtn()">
                            <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
                        </span>
                    </span>
                </div>
            </div>  
        </div>
    </div>
</div>

<!-- Executive Change -->
<ng-template #changeExecutive let-modal>
    <!--Header-->
    <div class="col-md-12 col-sm-12 col-12 mobAddLed">
        <div class="row">
            <div class="col-md-10 col-sm-10 col-10" style="padding: 15px 15px 10px 15px;">
                <h4 class="modal-title"><span id="ApntmntHdr">Executive</span></h4>
            </div>
            <div class="col-md-2 col-sm-2 col-2" style="padding: 15px 15px 10px 15px;">
                <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="col-md-12 col-sm-12 col-12 mobAddLed">
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-md-12 col-sm-12 col-12">
                <div>
                    <select class="form-control" style="cursor: pointer; padding: 0;">
                        <option value="0">Assign to</option>
                        <option value="{{u.UserID}}" *ngFor="let u of userList">{{u.Name}}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="margin-top: 10px;"> 
                <div class="btn btn-blue" 
                    style="font-size: 13px; padding: 0 15px; line-height: 30px; cursor: pointer;">
                    <i class="fa fa-check" style="margin-right: 5px;"></i> Save
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- Status Change -->
<ng-template #selectExcUser let-modal>
    <!--Header-->
    <div class="col-md-12 col-sm-12 col-12 mobAddLed">
        <div class="row">
            <div class="col-md-10 col-sm-10 col-10" style="padding: 15px 15px 10px 15px;">
                <h4 class="modal-title"><span style="font-size: 20px;">Assign to</span></h4>
            </div>
            <div class="col-md-2 col-sm-2 col-2" style="padding: 15px 15px 10px 15px;">
                <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
            </div>
        </div>
    </div>
    <!--Body-->
         <!-- Search User -->
         <div *ngIf="userList.length > 5" class="input-icons search" style="display: inline-block; width: 100%; margin-bottom: 10px;">
            <span class="fa fa-search"></span>
            <input class="form-control formCtlFltr brdrRadius3 searchBar userSearch" [(ngModel)]="search" placeholder="Search" 
            style="text-align: left; margin-right: 10px; display: inline-block; padding-left: 35px !important; padding: 2px;  box-shadow: none;font-size: 13px; height: 34.4px;"
            type="text">
        </div>
        <div class="col-md-12 col-sm-12 col-12 mobAddLed ExcecutiveListMain">
            <div class="ExcecutiveList">
                <div class="{{changeColorUserList(i % 7, U.UserID)}} brdrRadius3" *ngFor="let U of userList | filter:'Name':search | sort : 'Name' : 0,let i = index" style="padding-top: 10px;padding: 0px 3px !important;margin-bottom: 10px; padding-left: 15px; padding-right: 15px;display: inherit;">
                    <div (click)="selectExeChane(U.UserID)" style="padding: 0px 3px !important; padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;text-align: center;cursor: pointer;">{{U.Name}}</div>     
                </div>
            </div>
        </div>
</ng-template>

